import { render, staticRenderFns } from "./dictionary-maintenance.vue?vue&type=template&id=535d103c&scoped=true"
import script from "./dictionary-maintenance.vue?vue&type=script&lang=js"
export * from "./dictionary-maintenance.vue?vue&type=script&lang=js"
import style0 from "./dictionary-maintenance.vue?vue&type=style&index=0&id=535d103c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d103c",
  null
  
)

export default component.exports